<template>
  <content-dialog
    v-model="dialogOpen"
    :title="title"
    min-height="400px"
    transition-show="scale"
    close-icon="mdi-arrow-left"
    fullscreen-mobile
    no-backdrop-dismiss
    @hide="onHide"
  >
    <div class="q-pa-md">
      <template v-if="!!$slots.before">
        <slot name="before" />
        <q-separator class="q-my-md" />
      </template>

      <AddressInputContainer
        ref="input"
        :address="address"
        :required="required"
        :input-props="{outlined: true, dense: true}"
        :autocomplete-options="autocompleteOptions"
        :search-loading="searchLoading"
        :suggestions-label="suggestionsLabel"
        :allow-refresh-suggestions="allowRefreshSuggestions"
        :suggestions="suggestions"
        :error-message="errorMessage"
        :is-cleared="isCleared"
        @load-suggestions="$emit('loadSuggestions')"
        @refresh-suggestions="$emit('refreshSuggestions')"
      />

      <template v-if="!!$slots.after">
        <q-separator class="q-my-md" />
        <slot name="after" />
      </template>
    </div>

    <template #bottom>
      <q-toolbar>
        <q-btn
          v-if="!autoRemove"
          label="Remove"
          flat
          color="red-7"
          size="12px"
          @click="onRemove"
        />
        <q-space />
        <q-btn
          v-close-popup
          color="green"
          icon-right="mdi-check"
          label="Save"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
import AddressInputContainer from 'components/partials/address/AddressInputContainer.vue'
import searchMixin from 'components/partials/address/searchMixin'

/**
 * AddressDialog is a wrapper for address components for displaying in a dialog
 *
 * SLOTS:
 * - before: content to prepend before the address fields
 * - after: content to append after the address fields
 */
export default {
  components: {
    AddressInputContainer
  },
  mixins: [searchMixin],
  props: {
    address: {
      type: Object,
      required: true
    },
    // Display * for address line 1
    required: {
      type: Boolean,
      default: false
    },
    // Display error message above inputs
    errorMessage: {
      type: String,
      default: null
    },
    // Dialog title
    title: {
      type: String,
      default: 'Set Address'
    },
    // Emit "remove" when dialog is closed if the address object kv pairs are null
    autoRemove: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove', 'hide'],
  data () {
    return {
      dialogOpen: false
    }
  },
  computed: {
    isCleared () {
      return !this.address.address_line_1 &&
        !this.address.locality &&
        !this.address.postal_code &&
        !this.address.state &&
        !this.address.country
    }
  },
  methods: {
    onRemove () {
      this.close()

      this.timed(() => {
        this.$emit('remove')
      }, 250)
    },
    onHide () {
      if (this.autoRemove && this.isCleared) {
        this.$emit('remove')
      }

      this.$emit('hide')
    },
    close () {
      this.dialogOpen = false
    },
    open () {
      this.dialogOpen = true

      this.timed(() => {
        // Autofocus to address_line_1 input if the input field is empty
        if (this.$refs.input && !this.address.address_line_1) {
          this.$refs.input.focus()
        }
      }, 350)
    }
  }
}
</script>
